<ub-label *ngIf="translationInfo.length > 0" label="Original language" i18n-label>
  <span text>
    <app-badge variant="success" icon="check" [title]="originalLanguageCode"></app-badge>
  </span>
</ub-label>
<ub-label *ngIf="translationInfo.length > 0" label="Available translations" i18n-label>
  <span text *ngFor="let translation of translationInfo">
    <app-badge *ngIf="translation.isFullyTranslated" variant="success" icon="check" [title]="translation.languageCode"></app-badge>
    <app-badge *ngIf="!translation.isFullyTranslated" variant="warning" icon="close" [title]="translation.languageCode" ></app-badge>
  </span>
</ub-label>
